import React from 'react';

import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';

import { IconWrapper, Input, InputWrapper, Wrapper } from './styles';
export interface Props {
  placeholder?: string;
  value: string | number;
  type?: string;
  onChange: (value: any) => void;
  sticky?: boolean;
}

const SearchInput: React.FC<Props> = ({
  placeholder = '',
  value = '',
  type = 'text',
  onChange,
  sticky = false,
}) => {
  return (
    <Wrapper sticky={sticky}>
      <InputWrapper>
        <Input
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
        <IconWrapper>
          <SearchIcon />
        </IconWrapper>
        {value.toString().length > 0 && (
          <IconWrapper isRight>
            <CloseIcon
              htmlColor="var(--colorBlueGray600)"
              onClick={() => onChange('')}
              style={{ cursor: 'pointer' }}
            />
          </IconWrapper>
        )}
      </InputWrapper>
    </Wrapper>
  );
};

export default SearchInput;
